/**
 * `/admin/policies` — fino al 03-11-2026 «Policy aziendali», con quattro schede: ritardi, smart
 * working, pianificazione, calendario e riunioni. Stanno tutte in «Regole di lavoro», con gli stessi
 * pannelli: due porte sulle stesse regole prima o poi dicono due cose diverse, quindi la pagina non
 * c'è più e la voce di Configurazione nemmeno.
 *
 * La rotta resta per i segnalibri: la scheda dell'indirizzo (`#ritardi`, `#pianificazione`…) porta
 * alla sezione corrispondente.
 */
import { createFileRoute, Navigate } from '@tanstack/react-router';
import type { CompanySection } from '@/features/tenants/companySections';

export const Route = createFileRoute('/_app/admin/policies')({ component: PoliciesRedirect });

/** Scheda di «Policy aziendali» → sezione di «Regole di lavoro». */
const SECTION_BY_TAB: Record<string, CompanySection> = {
  ritardi: 'tardiness',
  'smart-working': 'work-modes',
  pianificazione: 'planning',
  calendario: 'planning',
};

function policiesSectionFor(hash: string): CompanySection {
  return SECTION_BY_TAB[hash.replace(/^#/, '')] ?? 'tardiness';
}

function PoliciesRedirect() {
  const hash = typeof window === 'undefined' ? '' : window.location.hash;
  return <Navigate to="/organization/work-rules" search={{ section: policiesSectionFor(hash) }} replace />;
}
